import React from "react";
import { Switch } from 'react-router-dom';
import { errorLayout } from '../../layouts/ErrorLayout';
import AppRoute from '../AppRoute';
import Loader from '../../helper/loaders';
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout';
import { auth } from '../../utils/authentication/auth';

const CreateLegal = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Legals/CreateLegal')
);

const EditLegal = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Legals/EditLegal')
);

const ManageLegal = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Legals/ManageLegal')
);

const LegalCenter = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Legals/LegalCenter')
);

const LegalDetails = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Legals/LegalDetails')
);

const NotFoundPage = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/not-found-page.component')
);


const LegalComponent = (props) => {
    let { match } = props;

    return (
        <React.Fragment>
            <Switch>

                <AppRoute
                    path={`${match.path}/create`}
                    component={CreateLegal}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='private'
                    title='Create Legal'
                />
                <AppRoute
                    path={`${match.path}/legal-details/:id`}
                    component={LegalDetails}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='private'
                    title='Legal Details'
                />
                <AppRoute
                    path={`${match.path}/edit/:id`}
                    component={EditLegal}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='private'
                    title='Update Legal'
                />
                <AppRoute
                    path={`${match.path}/legal-center/:id`}
                    component={LegalCenter}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='private'
                    title='Legal Center'
                />
                <AppRoute
                    path={`${match.path}/list-all`}
                    component={ManageLegal}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='private'
                    title='Manage Legal'
                />
                <AppRoute
                    path={`${match.path}/*`}
                    component={NotFoundPage}
                    requireAuth={() => false}
                    layout={errorLayout}
                    type='public'
                />

                <AppRoute
                    exact
                    path={`${match.path}`}
                    component={NotFoundPage}
                    requireAuth={() => false}
                    layout={errorLayout}
                    type='public'
                />

            </Switch>
        </React.Fragment>
    )
};

export default LegalComponent;